<template>
  <b-row>
    <el-dialog
      title="دیدگاه"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="80%"
    >
      <Comments :articleid="articleid" />
    </el-dialog>

    <el-dialog
      title="تغییر وضعیت مطلب"
      v-if="articlestatus"
      :visible.sync="articlestatus"
      :before-close="handleClosearticlestatus"
      width="30%"
    >
      <b-form-group class="w-100">
        <b-select v-model="articlest">
          <option
            v-for="(statusitem, index) in status"
            v-bind:key="index"
            :value="statusitem.value"
          >
            {{ statusitem.name }}
          </option>
        </b-select>
      </b-form-group>

      <b-button variant="info" @click="changestatussave">ذخیره</b-button>
    </el-dialog>
    <b-col md="12">
      <b-card>
        <template slot="header">
          <h3>مدیریت مطالب</h3>
          <b-col md="2" sm="12" class="left">
            <b-form-group>
              <b-select v-model="langcurent" @change="getall">
                <option value="all">همه زبان ها</option>
                <option
                  v-for="(langitem, index) in lang"
                  v-bind:key="index"
                  :value="langitem.id"
                >
                  {{ langitem.title }} [ {{ langitem.slug }} ]
                </option>
              </b-select>
            </b-form-group>
          </b-col>
        </template>
        <el-table
          class="table"
          :data="articles"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column
            width="80"
            align="center"
            prop="id"
            label="#"
            sortable
          >
          </el-table-column>

          <el-table-column
            prop="title"
            align="center"
            label="عنوان مطلب"
            sortable
          >
          </el-table-column>

          <el-table-column prop="cat" align="center" label="موضوع" sortable>
          </el-table-column>

          <el-table-column prop="lang" align="center" label="زبان" sortable>
          </el-table-column>

          <el-table-column prop="user" align="center" label="نویسنده" sortable>
          </el-table-column>

          <el-table-column align="center" label="تاریخ ارسال" sortable>
            <template slot-scope="scope">
              <div>{{ scope.row.date }}</div>
              <div class="changestatus" @click="changestatus(scope.row.id)">
                <small
                  v-if="scope.row.status == 0"
                  class="label label-sm label-success label-inline"
                  >منتشر شده</small
                >
                <small
                  v-else-if="scope.row.status == 1"
                  class="label label-sm label-info label-inline"
                  >پیش نویس</small
                >
                <small
                  v-else-if="scope.row.status == 2"
                  class="label label-sm label-danger label-inline"
                  >ارجاع</small
                >
                <small
                  v-else-if="scope.row.status == 3"
                  class="label label-sm label-dark label-inline"
                  >سایر</small
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center">
            <template slot="header" slot-scope="scope">
              <input
                v-model="search"
                size="mini"
                @keyup="searchinput"
                :class="scope.$index"
                placeholder="جستجو ..."
              />
            </template>

            <template slot-scope="scope">
              <button
                class="btn btn-sm btn-clean btn-icon"
                @click="showcomments(scope.row.id)"
                v-tooltip="{ content: 'دیدگاه های مطلب' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-comments"></i>
                </span>
              </button>

              <router-link
                :to="`/article/edit/${scope.row.id}`"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'ویرایش مطلب' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-edit"></i>
                </span>
              </router-link>

              <button
                @click="remove(scope.row.id)"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'حذف مطلب' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-trash"></i>
                </span>
              </button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager, next"
          :total="meta.total"
          :page-size="15"
          :page-count="meta.per_page"
          :current-page="meta.current_page"
          @current-change="changepage"
        >
        </el-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "",
  data() {
    return {
      lang: "",
      langcurent: "all",
      articles: [],
      links: [],
      meta: [],
      search: "",
      status: [
        {
          name: "انتشار",
          value: 0,
        },
        {
          name: "پیش نویس",
          value: 1,
        },
        {
          name: "ارجاع",
          value: 2,
        },
        {
          name: "سایر",
          value: 3,
        },
      ],
      dialogVisible: false,
      articlestatus: false,
      articleid: "all",
      page: 0,
      articlest: 0,
    };
  },
  mounted() {
    this.getall();
    this.getlang();
  },
  methods: {
    getall: function () {
      ApiService.query("admin/article", {
        params: {
          lang : this.langcurent,
          page : this.page
        }
      })
        .then(({ data }) => {
          this.articles = data.data;
          this.links = data.links;
          this.meta = data.meta;
        })
        .catch(({ response }) => {});
    },
    getlang: function () {
      ApiService.get("admin/langlist#", {})
        .then(({ data }) => {
          this.lang = data;
        })
        .catch(({ response }) => {});
    },
    showcomments(id) {
      this.articleid = id;
      this.dialogVisible = true;
    },
    changestatus(id) {
      this.articleid = id;
      this.articlestatus = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClosearticlestatus() {
      this.articlestatus = false;
    },
    remove: function (id) {
      let thisv = this;
      ApiService.delete("admin/article/" + id)
        .then(({ data }) => {
          this.changepage(this.page);

          this.$vs.notification({
            progress: "auto",
            color: "danger",
            position: "bottom-left",
            text: "مطلب با موفقیت حذف شد",
          });
        })
        .catch(({ response }) => {});
    },
    changestatussave: function () {
      let thisv = this;
      ApiService.post("admin/article/changestatus", {
        article: this.articleid,
        status: this.articlest,
      })
        .then(({ data }) => {
          this.changepage(this.page);

          this.$vs.notification({
            progress: "auto",
            color: "success",
            position: "bottom-left",
            text: "وضعیت مطلب با موفقیت ویرایش شد",
          });
        })
        .catch(({ response }) => {});
    },
    changepage: function (page) {
      let thisv = this;
      this.page = page;
      ApiService.query("admin/article", {
        params: {
          lang : this.langcurent,
          page : this.page
        }
      })
        .then((response) => {
          thisv.articles = response.data.data;
          thisv.meta = response.data.meta;
          thisv.links = response.data.links;
        })
        .catch(({ responsea }) => {});
    },

    searchinput: function (event) {
      let search = this.search;
      if (this.search.length > 2) {
        let thisv = this;

        ApiService.post("admin/article/searchmng", {
          search,
        })
          .then((response) => {
            thisv.articles = response.data.data;
            thisv.meta = response.data.meta;
            thisv.links = response.data.links;
          })
          .catch(({ responsea }) => {});
      } else if (this.search.length == 0) {
        this.changepage(this.page);
      }
    },
  },
};
</script>
<style>
.color-red {
  color: brown;
}
.changestatus {
  cursor: pointer;
}
</style>
